import { render } from "./NavView.vue?vue&type=template&id=2de807f5&scoped=true"
import script from "./NavView.vue?vue&type=script&lang=js"
export * from "./NavView.vue?vue&type=script&lang=js"

import "./NavView.vue?vue&type=style&index=0&id=2de807f5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de807f5"]])

export default __exports__